import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPen, faPhone } from '@fortawesome/free-solid-svg-icons';

const DeliveryPreview = ({ delivery, onClick, isActive }) => {
  return (
    <div onClick={onClick} className={`delivery-preview m-b-3 ${isActive ? 'm-active' : ''}`}>
      <div className="delivery-preview__name">
        <strong>{delivery.name}</strong> <small className="text-muted">#{delivery.id} </small>
      </div>
      <div className="text-muted m-b-1">
        <small>
          <FontAwesomeIcon icon={faMapMarkerAlt} /> {`${delivery.unit ? `${delivery.unit}, ` : ''}${delivery.address}`}
        </small>
      </div>
      {delivery.phoneNumber ? (
        <div className="m-b-1">
          <FontAwesomeIcon icon={faPhone} /> {delivery.phoneNumber}
        </div>
      ) : (
        ''
      )}
      {delivery.email ? (
        <div className="m-b-1">
          <FontAwesomeIcon icon={faPen} /> {delivery.email}
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

DeliveryPreview.defaultProps = {
  onClick: () => {},
};

export default DeliveryPreview;
